/** Unit-neutral display data. Never infer a policy from a rate's magnitude. */
export interface RewardView {
  rewardPolicyVersion: string | null;
  rewardRate: number | null;
  rewardDenominator: 10_000 | 1_000_000 | null;
}

interface RewardDto {
  rewardPolicyVersion?: string | number | null | undefined;
  rewardRate?: number | null | undefined;
  rewardDenominator?: number | null | undefined;
  rewardBps?: number | null | undefined;
  rewardPpm?: number | null | undefined;
}

export function normalizeReward(dto: RewardDto, finalized = true): RewardView {
  const version = dto.rewardPolicyVersion == null ? null : String(dto.rewardPolicyVersion);
  const expected = version === "1" ? 10_000 : version === "2" ? 1_000_000 : null;
  // Explicit null remains unknown. Only old V1 responses may omit unit/rate fields.
  const denominator = dto.rewardDenominator === undefined && version === "1" ? 10_000 : dto.rewardDenominator;
  const known = expected !== null && denominator === expected;
  const rate = dto.rewardRate !== undefined ? dto.rewardRate :
    version === "1" ? dto.rewardBps : version === "2" ? dto.rewardPpm : null;
  return { rewardPolicyVersion: version,
    rewardDenominator: known ? expected : null,
    rewardRate: known && finalized && rate != null && Number.isSafeInteger(rate) && rate >= 0 && rate <= expected ? rate : null };
}
